// extracted by mini-css-extract-plugin
export default {"selector":"veb4Z","icon":"LFG4j","wrapper":"HsOTa","prefix":"DOg95","selectorOptions":"f8sbW","selectorOption":"xxzys","employeeEdit":"NJLSX"};